import { Integration } from "./integration";

export class Integrations extends Array<Integration> {
  constructor(integrations?: Integration[]) {
    super();
    if (integrations instanceof Array) {
      integrations.forEach((integration) => this.push(integration));
    }
  }

  has_provider(provider: string): boolean {
    return this.some((integration) => integration.provider == provider);
  }
}
